import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setOtherTexts = info => {
	return {
		type: ActionTypes.LOAD_OTHERTEXTS,
		otherTexts: info.data
	};
};
/*
export const onUpdateInformativeText = response => {
	return {
		type: ActionTypes.MODIFY_INFORMATIVETEXT,
		response: response
	};
};
*/

export const loadOtherTexts = () => {
	return dispatch => {
		axios
			.get("https://getupstudio.co/solanasapi/otrostextos")
			.then(response => {
				dispatch(setOtherTexts(response.data));
			})
			.catch(error => {});
	};
};

export const saveOtherText = (otherText) => {

	console.log(otherText);

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/otrostextos/edit",
				otherText
			)
			.then(response => {
				dispatch(loadOtherTexts());
			})
			.catch(error => {});
	};
};
